import { Button, Col, ConfigProvider, Row, Tabs } from "antd";
import "./Tabs_User.scss";
import { MdAddToPhotos } from "react-icons/md";
import { Link } from "react-router-dom";
import { PiHeartFill } from "react-icons/pi";
import { useContext, useEffect, useState } from "react";
import { getProductsDetails } from "../../services/productsDetails/productsDetails";
import { UserContext } from "../../context/userContext";
import { formatNumber } from "../../helper/fomartNum";
import { priceNew } from "../../helper/priceNew";
import {
  getOffersByShop,
  getOffersByUser,
  getProductsByShop,
} from "../../services/user/user";
import Tab_Requests from "./Tab_Request";
import Tab_UserRequests from "./Tab_UserRequests";
import { OffersContext } from "../../context/offersContext";

function Tab_User() {
  const { currentUser } = useContext(UserContext);
  const { tempPrices } = useContext(OffersContext);

  const [likedProducts, setLikedProducts] = useState([]);
  const [sellingProducts, setSellingProducts] = useState([]);
  const [soldProducts, setSoldProducts] = useState([]);
  const [requests, setRequests] = useState([]);
  const [userOffers, setUserOffers] = useState([]);

  useEffect(() => {
    if (!currentUser) return;

    const fetchData = async () => {
      // ===== THÍCH =====
      if (currentUser?.liked?.length > 0) {
        const results = await Promise.all(
          currentUser.liked.map((id) => getProductsDetails(id))
        );
        setLikedProducts(results.map((r) => r[0]).filter(Boolean));
      } else {
        setLikedProducts([]);
      }

      // ===== SHOP =====
      const allProductsByShop = await getProductsByShop(currentUser.username);

      setSellingProducts(allProductsByShop.filter((p) => p.stock === true));
      setSoldProducts(allProductsByShop.filter((p) => p.stock === false));

      // ===== OFFERS =====
      setRequests(await getOffersByShop(currentUser.username));
      setUserOffers(await getOffersByUser(currentUser.username));
    };

    fetchData();
  }, [currentUser]);

  // COMPONENT ITEM SẢN PHẨM (CLICK / KHÓA CLICK)
  const ProductItem = ({ product, hasSoldTag = false }) => {
    const Wrapper = product.stock ? Link : "div";

    return (
      <Wrapper
        to={
          product.stock
            ? `/products/${product.id || product.idProducts}`
            : undefined
        }
        className={`products-item ${!product.stock ? "disabled" : ""}`}
      >
        <img src={product.thumbnail1} className="img" />
        <img src={product.thumbnail2} className="img-abs" />

        {hasSoldTag && <div className="sold-label">ĐÃ BÁN</div>}
      </Wrapper>
    );
  };

  const items = [
    // ===== TAB ĐANG BÁN =====
    {
      key: "1",
      label: "Đang bán",
      children:
        sellingProducts.length > 0 ? (
          <div className="tab-user-selling">
            <Row gutter={[20, 20]}>
              {sellingProducts.map((p) => (
                <Col xxl={4} xl={4} key={p.id}>
                  <Link to={`/products/${p.id}`}>
                    <div className="products-item">
                      <img src={p.thumbnail1} className="img" />
                      <img src={p.thumbnail2} className="img-abs" />
                      <div className="price_new">
                        {formatNumber(priceNew(p.price_old, p.sales))}
                        <span className="underline">đ</span>
                      </div>
                    </div>
                  </Link>
                </Col>
              ))}
            </Row>
          </div>
        ) : (
          <div className="tab-user-sell">
            <div className="tab-user-sell-wrapper">
              <MdAddToPhotos className="icon-sell" />
              <div className="details">
                Bắt đầu bán từ hôm nay và biến gu thời trang của bạn thành nguồn
                thu nhập thực tế.
              </div>

              <Link to="/products/create">
                <Button className="btn-sell">Bán sản phẩm</Button>
              </Link>
            </div>
          </div>
        ),
    },

    // ===== TAB THÍCH =====
    {
      key: "2",
      label: "Thích",
      children:
        likedProducts.length > 0 ? (
          <div className="tab-user-like-products">
            <Row gutter={[20, 20]}>
              {likedProducts.map((item) => {
                const Wrapper = item.stock ? Link : "div";

                return (
                  <Col xxl={4} xl={4} key={item.idProducts}>
                    <Wrapper
                      to={item.stock ? `/products/${item.id}` : undefined}
                      className={`products-item ${
                        !item.stock ? "disabled" : ""
                      }`}
                    >
                      <img src={item.thumbnail1} className="img" />
                      <img src={item.thumbnail2} className="img-abs" />
                      {!item.stock && <div className="sold-label">ĐÃ BÁN</div>}

                      <div className="name-products">{item.name}</div>
                      <div className="price_new">
                        {formatNumber(
                          tempPrices[item.idProducts] ??
                            priceNew(item.price_old, item.sales)
                        )}
                        <span className="underline">đ</span>
                      </div>
                    </Wrapper>
                  </Col>
                );
              })}
            </Row>
          </div>
        ) : (
          <div className="tab-user-like">
            <div className="tab-user-like-wrapper">
              <PiHeartFill className="icon-like" />
              <div className="title">
                Những mục bạn thích sẽ xuất hiện ở đây.
              </div>
              <Link to="/">
                <Button className="btn-find">Tìm kiếm</Button>
              </Link>
            </div>
          </div>
        ),
    },

    // ===== TAB ĐÃ BÁN =====
    {
      key: "3",
      label: "Đã bán",
      children:
        soldProducts.length > 0 ? (
          <div className="tab-user-soldOut">
            <Row gutter={[20, 20]}>
              {soldProducts.map((p) => (
                <Col xxl={4} xl={4} key={p.id}>
                  <div className="products-item disabled">
                    <img src={p.thumbnail1} className="img" />
                    <img src={p.thumbnail2} className="img-abs" />
                    <div className="sold-label">ĐÃ BÁN</div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        ) : (
          <div className="tab-user-sold">
            <div className="tab-user-sold-wrapper">
              <div className="title">
                Những sản phẩm bạn đã bán sẽ xuất hiện ở đây.
              </div>
              <Link to="/products/create">
                <Button className="btn-sold">Bán sản phẩm</Button>
              </Link>
            </div>
          </div>
        ),
    },

    // ===== YÊU CẦU =====
    {
      key: "4",
      label: "Yêu cầu của tôi",
      children:
        requests.length > 0 ? (
          <Tab_Requests />
        ) : (
          <div className="empty-tab">Chưa có yêu cầu</div>
        ),
    },

    // ===== ĐỀ NGHỊ =====
    {
      key: "5",
      label: "Đề nghị của tôi",
      children:
        userOffers.length > 0 ? (
          <Tab_UserRequests />
        ) : (
          <div className="empty-tab">Chưa có đề nghị</div>
        ),
    },
  ];

  return (
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            titleFontSize: 18,
            itemHoverColor: "#000",
            itemColor: "#747474",
            itemActiveColor: "#000",
            itemSelectedColor: "#000",
            inkBarColor: "#000",
          },
        },
      }}
    >
      <Tabs defaultActiveKey="1" items={items} className="tab-user" />
    </ConfigProvider>
  );
}

export default Tab_User;
